export class VehicleIdentifierValidator {
    private static REGEX_VIN = /^[A-HJ-NPR-Z\d]{13}\d{4}$/;
    private static REGEX_COMMISSION_NUMBER_WITH_YEAR = /^\d{4}[A-Z0-9]{6}$/;
    private static REGEX_COMMISSION_NUMBER = /^[A-Z\d]{6}$/;
    private static COMMERCIAL_VEHICLES_WMI = ['WV1', 'WV2', 'WV3', 'WV4'];

    public static isValid(vehicleId: string): boolean {
        return VehicleIdentifierValidator.isValidVin(vehicleId)
            || VehicleIdentifierValidator.isValidCommissionNumber(vehicleId)
            || VehicleIdentifierValidator.isValidCommissionNumberWithYear(vehicleId)
            || VehicleIdentifierValidator.isValidInventoryNumber(vehicleId);
    }

    public static isValidVin(vehicleId: string | undefined): boolean {
        return !!vehicleId && VehicleIdentifierValidator.REGEX_VIN.test(vehicleId);
    }

    public static isValidCommissionNumber(vehicleId: string): boolean {
        return VehicleIdentifierValidator.REGEX_COMMISSION_NUMBER.test(vehicleId);
    }

    public static isValidCommissionNumberWithYear(vehicleId: string): boolean {
        return VehicleIdentifierValidator.REGEX_COMMISSION_NUMBER_WITH_YEAR.test(vehicleId);
    }

    public static isValidInventoryNumber(vehicleId: string): boolean {
        return VehicleIdentifierValidator.isValidCommissionNumber(vehicleId.slice(1));
    }

    public static isCommercialVehicleVin(vehicleId: string | undefined): boolean {
        return VehicleIdentifierValidator.isValidVin(vehicleId)
            && VehicleIdentifierValidator.COMMERCIAL_VEHICLES_WMI.includes(vehicleId!.slice(0, 3));
    }
}